<template>
  <!-- pc -->
  <div class="static-1">
    <div class="page">
      <div class="video-overlay"
           :style="{
            backdropFilter: `blur(${currentScroll % innerHeight / 15}px)`,
            backgroundColor: `rgba(128, 128, 128, ${ currentPage > 1 && currentScroll % innerHeight > innerHeight / 2 ? 0.1 : currentScroll > currentScroll / innerHeight / 2.5 })`}"
      ></div>
      <div v-if="showBgVideo && currentPage < 3" class="video-box">
        <video v-show="!showFullVideo" width="100%" height="100vh" ref="videoPlayerFull" id="videoPlayerFull"
               class="swiper-video"
               :muted="true"
               :autoplay="true"
               :loop="true"

               :src="coverVideoUrlPc"
               :playsinline="true" :webkit-playsinline="true" :x5-playsinline="true" x5-video-player-type="h5"
        ></video>
        <!-- <img class="kv-img swiper-video" src="/assets/~/media/images/activity/film2505-prod/pc/kv.jpg" alt=""/> -->
      </div>
      <div class="page-1">
        <div class="logo-box">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-1-logo.png" alt=""/>
        </div>
        <div class="left-text">
<!--          <img src="./image/page-1-left-text.png" alt=""/>-->
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-1-left-text.png" alt=""/>
        </div>
        <div class="video-play" @click="showPopVideo(1)"
        code-ga="event, PAGEURL, PC_完整视频播放"
          code-stm="event, PAGEURL, PC_完整视频播放">
          <img src="/assets/~/media/images/activity/film2505-prod/button/pc/video-play-button.png" alt=""/>
<!--          <div class="video-play-text">完整预告</div>-->
        </div>
        <div class="audio-play" @click="handleAudio">
          <img v-if="isAudioPlaying" style="width: calc(42 / 1920 * 100vw);height:calc(25 / 1920 * 100vw);margin-top:calc(20 / 1920 * 100vw);margin-left:calc(12 / 1920 * 100vw)"
           src="/assets/~/media/images/activity/film2505-prod/button/playing.gif" alt=""/>
          <img v-else style="width: calc(42 / 1920 * 100vw);height:calc(25 / 1920 * 100vw);margin-top:calc(20 / 1920 * 100vw);margin-left:calc(12 / 1920 * 100vw)"
           src="/assets/~/media/images/activity/film2505-prod/button/gif-img.png" alt=""/>
          <div class="audio-text show" >
            <img v-if="!isAudioPlaying" src="/assets/~/media/images/activity/film2505-prod/button/pc/audio-paused.png" alt=""/>
            <img v-else src="/assets/~/media/images/activity/film2505-prod/button/pc/audio-playing.png" alt=""/>
          </div>
        </div>
      </div>
      <div :class="{'page-2': true,}"> <!-- 'bg': currentPage === 3} -->
        <div v-show="showPage2Bg" class="page-bg1">
<!--          <img class="page-bg1-img" src="./image/page-2-bg2.png" alt=""/>-->
        </div>
        <div class="page-bg-left">
<!--          <img class="page-bg-left-img" src="/assets/~/media/images/activity/film2505-prod/pc/page-2-bg1.png" alt=""/>-->
        </div>
        <!-- <div class="logo-box">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
        </div> -->
        <div class="text-box">
          <div class="text-1">
            <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-text1.png" alt=""/>
          </div>
          <div class="text-2">
            <img class="text-2-img1" src="/assets/~/media/images/activity/film2505-prod/pc/page-2-text2.png" alt=""/>
            <img :class="{'text-2-img2': true, 'animate__animated animate__fadeInUp': shouldAnimate }" src="/assets/~/media/images/activity/film2505-prod/pc/page-2-text3.png" alt=""/>
          </div>
        </div>
      </div>



      <!--   第三屏开始   -->

      <div class="animatepage" id="animatepage">
        <div class="overlay" id="overlay"></div>
        <!-- <div class="overlay" id="overlay2"></div> -->
        <div class="background1" id="background1">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/cbg.png" alt="" />
        </div>
        <!-- <div class="background2" id="background2">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/dbg.png" alt="" />
        </div> -->
        <div class="coverimg1" id="coverimg1">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/cpic2.png" alt="" />
        </div>

        <!-- 剧情梗概 -->
        <div class="coverimg3" >
          <img id="cover3bg" class="big-bg" style="transform: scaleY(-1);" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao-bg.png" alt="" />
          <div>
            <img id="coverimg3" class="cover3-img" src="/assets/~/media/images/activity/film2505-prod/pc/epic.jpg" alt="">
          </div>
          <!-- 两个播放按钮 热区 -->
          <div class="button-up button-play" @click="showPopVideo(2)"
          code-ga="event, PAGEURL, 上卷_视频播放"
          code-stm="event, PAGEURL, 上卷_视频播放"></div>
          <div class="button-down button-play" @click="showPopVideo(3)"
          code-ga="event, PAGEURL, 下卷_视频播放"
          code-stm="event, PAGEURL, 下卷_视频播放"></div>
        </div>
        <!-- 剧照 -->
        <div class="coverimg2" >
          <img class="big-bg" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao-bg.png" alt="" />
          <div id="coverimg2">
            <img class="juzhao-logo" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/juzhao-logo.png" alt="">
            <img class="bg-1 bg" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/01a.jpg" alt="">
            <img class="bg-2 bg" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/02a.jpg" alt="">
            <img class="bg-3 bg" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/03a.jpg" alt="">
            <img class="bg-4 bg" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/04a.jpg" alt="">
            <img v-for="(pic, index) in picImages" :key="index" code-stm="event, PAGEURL, 剧照_查看"
            :class="[`pic-${index+1}`, 'pic']" :src="pic.src" alt="" @click="showPop(index)">
          </div>
        </div>

        <!-- <div class="logo-box">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
        </div>
        <div class="logo-box2" id="logo2">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
        </div> -->
        <!-- <div class="logo-box3" id="logo3">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
        </div> -->
        <!-- 弹窗 -->

        <div id="" class="pop-overlay" v-if="isShowPop"></div><!-- 遮罩层 -->
        <div id="" class="pop-img" v-if="isShowPop">
          <img :src="popimgSrc" alt="">
        </div>
        <img class="pop-close" @click="hideCover" code-stm="event, PAGEURL, 剧照弹窗_关闭"
             v-if="isShowPop" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/close.png" alt="">

      </div>


    </div>
    <!-- 视频封面 -->
    <div class="cover-video" v-if="isShowCover">
      <div class="pop">
        <div class="pop-video" v-if="isShowVideo">
          <video class="my-video" :src="fullVideoUrl" autoplay="true" loop="false"
            :muted="false" direction="0" controls></video>
        </div>
        <i :class="['el-icon-error', 'error-icon', 'cursor-p']" @click="hideCover2"
          code-stm="event, PAGEURL, 大电影视频_关闭弹窗"></i>
      </div>
    </div>

    <div v-show="currentPage > 2 && isUperFoot" class="play-video" @click="showPopVideo(1)"
      code-ga="event, PAGEURL, 完整视频播放"
          code-stm="event, PAGEURL, 完整视频播放">
      <img src="/assets/~/media/images/activity/film2505-prod/button/pc/video-play-button2.png" alt=""/>
    </div>
    <div v-show="currentPage > 2 && isUperFoot" class="play-audio" @click="handleAudio" >
      <img v-if="isAudioPlaying" style="width: calc(42 / 1920 * 100vw);height:calc(25 / 1920 * 100vw);margin-top:calc(14 / 1920 * 100vw);margin-left:calc(12 / 1920 * 100vw)"
      src="/assets/~/media/images/activity/film2505-prod/button/playing.gif" alt=""/>
      <img v-else style="width: calc(42 / 1920 * 100vw);height:calc(25 / 1920 * 100vw);margin-top:calc(14 / 1920 * 100vw);margin-left:calc(12 / 1920 * 100vw)"
      src="/assets/~/media/images/activity/film2505-prod/button/gif-img.png" alt=""/>
      <div class="audio-text show">
        <img v-if="!isAudioPlaying" src="/assets/~/media/images/activity/film2505-prod/button/pc/audio-paused2.png" alt=""/>
        <img v-else src="/assets/~/media/images/activity/film2505-prod/button/pc/audio-playing2.png" alt=""/>
      </div>
    </div>
    <!-- 开头金弹窗
    <el-dialog title="" :visible.sync="isShowGold" append-to-body >
        <div class="gold-cover" v-show="isShowGold" @click="closePop" code-stm="`event, PAGEURL, 关闭提示弹窗`"></div>
        <img src="/assets/~/media/images/activity/film2505-prod/mob/gold-close.png"
            class="gold-el-icon-close el-icon-close-mob" @click="closePop" style="z-index: 9999;"
            code-stm="`event, PAGEURL, 关闭提示弹窗`">
        <div class="gold-pop">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/gold-popup.png" alt="">
        </div>
        <div class="click-area" @click="closePopAndPlayVideo" code-stm="event, PAGEURL, 关闭提示弹窗并播放视频"></div>
    </el-dialog>-->
  </div>

</template>

<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
export default {
  props: {
    isAudioPlaying: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isShowGold:false,
      isUperFoot:false,
      isPortrait: isPortraitFun(),
      videoVisible: false,
      isWxAndroid: false,
      videoSrc: "",

      showIcon: true,
      showFullVideo: false,
      preText: 'https://www.kia.cn',
      //视频封面PC端
      // previewImgUrl: '/assets/~/media/images/activity/aowanganimate/static1-videocover-pc.jpg',

      //视频资源
      fullVideoUrl: 'https://img.kia.cn/media/videos/202506/dadianying-all-guanwang.mp4',
      // fullVideoUrl: '',
      fullVideozUrl: '/assets/~/media/images/activity/aowanganimate/static1-videocover-pc.jpg',

      //视频背景资源
      coverVideoUrlPc: 'https://img.kia.cn/media/videos/202506/dadianying-fengmian-guanwang.mp4',
      coverVideoPosterPc: '/assets/~/media/images/activity/aowangAnimate/twopage-videocover-pc.jpg',

      isShowVideo: false,
      isShowCover: false,
      currentScroll: 0,
      innerHeight: window.innerHeight,
      currentPage: 1,
      showBgVideo: true,
      shouldAnimate: false, // 控制动画是否生效
      shouldScaleUp: false,
      shouldScaleDown: false,
      showPage2Bg: false,

      // 音频控制相关状态
      // isAudioPlaying: false,
      showAudioText: true,
      isHovering: false,

      // 第三屏开始
      isShowPop: false,

      textShowPc1: false,
      textShowPc2: false,
      textShowMob1: false,
      textShowMob2: false,

      // 图片数组
      picImages: [
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/01.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/02.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/03.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/04.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/05.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/06.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/07.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/08.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/09.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/10.png" }
      ],
      //弹窗图片数组
      popimgList: [
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p1.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p2.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p3.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p4.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p5.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p6.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p7.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p8.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p9.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/popup/p10.png" }
      ]

    };
  },
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true
      } else {
        return false
      } //判断是否Safari浏览器
    }
  },
  watch: {
    videoVisible(n) {
      if (!n) {
        this.close()
      }
    }
  },
  mounted() {

    const video = document.querySelector('.swiper-video');
    let lastScroll = 0;

    let that = this
    window.addEventListener('scroll', () => {
      //判断是否在footer之上
      if(document.getElementById("page5")){
        var pageTopMob= document.getElementById("page5").getBoundingClientRect().top
      }
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      if (pageTopMob < 0) {
        this.isUperFoot = false
      } else {
        this.isUperFoot = true
      }
      this.currentScroll = window.pageYOffset;
      this.currentPage = Math.floor(this.currentScroll / this.innerHeight) + 2;

      // console.log('this.currentPage', this.currentPage, this.currentScroll / this.innerHeight);

      const currentScroll = window.pageYOffset;
      const scrollDelta = currentScroll - lastScroll;
      lastScroll = currentScroll;

      // 模糊强度控制
      /*document.documentElement.style.setProperty('--scroll-progress',
        Math.min(currentScroll / 500, 1)
      );*/

      // 视频淡出逻辑
      if(currentScroll > window.innerHeight) {
        // video.style.opacity = 0.5;
        // video.style.pointerEvents = 'none';
      } else {
        // video.style.opacity = 1 - currentScroll / window.innerHeight - 0.3;
      }

      // 从第一屏过渡到第二屏
      const page2 = document.querySelector('.page-2');
      page2.style.backgroundColor  = `rgba(128, 128, 128, ${currentScroll / window.innerHeight * 0.2})`
      if (this.currentPage === 2 && ((currentScroll % window.innerHeight)  > (window.innerHeight - 300))){
        this.showBgVideo  = false
      } else {
        this.showBgVideo = true;
      }
      if (scrollDelta > 0 && this.currentPage === 2 && ((currentScroll % window.innerHeight) > (window.innerHeight - 350))) {
        this.shouldAnimate = true; // 触发动画
      } else {
        this.shouldAnimate = false;
      }


      // 第二屏背景
      if (this.currentPage > 1 && ((currentScroll % window.innerHeight) > (window.innerHeight - 300))) {
        this.showPage2Bg = true;
        const pageBg1 = document.querySelector('.page-bg1');
        pageBg1.style.opacity = currentScroll / window.innerHeight
      }

      // 第二屏从下往上滚动
      if (scrollDelta < 0 && ((this.currentScroll / this.innerHeight) < 0.7) && this.currentPage === 2) {
        this.showPage2Bg = false;
        const pageBg1 = document.querySelector('.page-bg1');
        pageBg1.style.opacity = 0.2
      }

      // 第二屏左侧背景做淡入淡出效果
      const pageBgLeft = document.querySelector('.page-bg-left');

      if (scrollDelta > 0 && this.currentPage === 2 && (currentScroll % window.innerHeight) > (window.innerHeight / 2)) {
        pageBgLeft.style.transform  = `scale(${currentScroll % window.innerHeight / window.innerHeight})`;
      }

      // 第二屏往上滚时变小
      if (scrollDelta < 0 && this.currentPage === 2) {
        let scale = currentScroll % window.innerHeight / window.innerHeight
        pageBgLeft.style.transform  = `scale(${ scale })`;
        pageBgLeft.style.opacity = scale
      }

      // 从第三屏往上滚动时变小
      if (scrollDelta < 0 && (this.currentPage === 3 ) && currentScroll % window.innerHeight < (window.innerHeight / 2 + 200)) {
        pageBgLeft.style.transform  = `scale(1)`;
        // pageBgLeft.style.transform  = `scale(${1 - currentScroll % window.innerHeight / window.innerHeight})`;
      }


      // 滚向第三屏时再变小
      if (scrollDelta > 0 && this.currentPage === 3 && currentScroll % window.innerHeight > 200) {
        let scale = 1 - currentScroll % window.innerHeight / window.innerHeight / 2;
        // pageBgLeft.style.transform  = `scale(${ scale })`;
        // pageBgLeft.style.opacity = 1 - scale + 0.2
        pageBgLeft.style.opacity = 1
      }

      if (scrollDelta > 0 && this.currentPage === 2 && currentScroll % window.innerHeight / window.innerHeight > 0.5) {
        pageBgLeft.style.opacity = 0.5 + (currentScroll % window.innerHeight / window.innerHeight - 0.5)
      }



      /* 第三屏开始 */

      var scrollPosition = window.scrollY;
      var vh = window.innerHeight;
      var vw = window.innerWidth;
      var pageTop = document
        .getElementById("animatepage")
        .getBoundingClientRect().top;
      //背景
      var background1Element = document.getElementById("background1");
      var background2Element = document.getElementById("background2");
      //书的图
      var bookElement = document.getElementById("coverimg3");
      var logo3Element = document.getElementById("logo2");
      var coverimg2Element = document.getElementById("coverimg2");
      var cover3bgElement = document.getElementById("cover3bg");


      var overlayElement = document.getElementById("overlay");
      // var videoElement2 = document.getElementById("overlay2");
      // var videooverlay = this.document.getElementsByClassName('video-overlay')
      // var page2 = this.document.getElementsByClassName('page-2')
      // var style = page2[0].style;
      // var backdropFilter =style.backdropFilter
      // var backgroundColor = style.backgroundColor;
      // debugger

      // 计算滚动进度百分比，用于控制透明度
      var scrollProgress
      var targetPosition = -25 * vh / 100 - (619 / 2200) * vw;
      var targetPosition2 = -25 * vh / 100 - (1238 / 2200) * vw;
      var targetPosition3  = -50 * vh / 100 - (1238 / 2200) * vw - (619 / 2200) * vw;
      var targetPosition4  = -50 * vh / 100 - (1238 / 2200) * vw - (619 / 2200) * vw - (419 / 2200) * vw;
      var targetPosition5 = -50 * vh / 100 - (1238 / 2200) * vw - (1238 / 2200) * vw - (419 / 2200) * vw;

      if (this.currentPage > 3 && ((currentScroll % window.innerHeight) > (window.innerHeight / 2))) {
        overlayElement.style.display = "block";
      }

      if(pageTop > 0){
        //遮罩跟随，隐藏背景1
        // overlayElement.style.display = "block";
        overlayElement.style.position = "absolute";
        background1Element.style.display = "none";
        overlayElement.style.display = "none";
      }
      else if (pageTop <= 0 && pageTop > -vh / 4 ) {
        overlayElement.style.display = "block";
        overlayElement.style.position = "fixed";
        // 第一阶段：从1减小到0
        scrollProgress = 1 - Math.abs(pageTop) / (vh / 8);
        //固定背景1，显示背景1
        background1Element.style.position = "fixed";
        background1Element.style.top = "78px";
        background1Element.style.bottom = "auto";
        background1Element.style.display = "block";

        background1Element.style.transform =  1 ;
        //隐藏图片3
        // bookElement.style.display = "none";

        // coverimg2Element.style.display = "none";
      } else if (pageTop <= -vh / 4 && pageTop > targetPosition) {
        overlayElement.style.display = "block";
        overlayElement.style.position = "fixed";
        //显示背景1
        background1Element.style.display = "block";
        background1Element.style.position = "fixed";
        // 第二阶段：从0增加到1
        var totalDistance = Math.abs(targetPosition + vh / 4);
        var currentDistance = Math.abs(pageTop + vh / 4);
        scrollProgress = currentDistance / totalDistance;
        // 背景1的缩放
        var scale = that.calculateScale(scrollProgress)
        background1Element.style.transform = `scale(${scale}) `;
        //隐藏图片3
        // bookElement.style.display = "none";

        // coverimg2Element.style.display = "none";

        overlayElement.style.position = "absolute";
        overlayElement.style.display = "none";

      }
      // else if (pageTop <= targetPosition && pageTop > targetPosition2) {
      //   console.log("3333");
      //   overlayElement.style.display = "block";
      //   overlayElement.style.position = "fixed";
      //   //背景2开始了
      //   //隐藏背景1
      //   background1Element.style.display = "none";
      //   // 第三阶段：从1减小到0
      //   var totalDistance = Math.abs(targetPosition2 - targetPosition);
      //   var currentDistance = Math.abs(pageTop - targetPosition);
      //   scrollProgress = 1 - currentDistance / totalDistance;

      //   bookElement.style.display = "block";
      //   logo3Element.style.display = "block";
      //   coverimg2Element.style.display = "block";
      // }
      else{
        overlayElement.style.position = "absolute";
        overlayElement.style.display = "none";
      }
      // 应用计算出的透明度值
      overlayElement.style.opacity = scrollProgress;
      background1Element.style.opacity = 1 - scrollProgress;

      //梗概
      if (pageTop <= targetPosition && pageTop > targetPosition2) {
        //背景2开始了
        //隐藏背景1
        background1Element.style.display = "none";
        // 第三阶段：从1减小到0
        var totalDistance = Math.abs(targetPosition2 - targetPosition);
        var currentDistance = Math.abs(pageTop - targetPosition);
        scrollProgress = 1 - currentDistance / totalDistance;
        // scrollProgress = currentDistance / totalDistance;
        cover3bgElement.style.opacity = scrollProgress;
        // bookElement.style.display = "block";
        // logo3Element.style.display = "block";
        // coverimg2Element.style.display = "block";
        coverimg2Element.style.opacity = 0;
      }

      //剧照
      if (pageTop <= targetPosition2 && pageTop > targetPosition3) {
        // overlayElement.style.display = "block";
        // overlayElement.style.position = "fixed";

        // coverimg2Element.style.display = "none";
        var totalDistance = Math.abs(targetPosition3 - targetPosition2);
        var currentDistance = Math.abs(pageTop - targetPosition2);
        scrollProgress = currentDistance / totalDistance;
        coverimg2Element.style.opacity = scrollProgress;
        cover3bgElement.style.opacity = 0
      }
      // else if (pageTop <= targetPosition3 && pageTop > targetPosition4 ) {
      //   // overlayElement.style.display = "block";
      //   // overlayElement.style.position = "fixed";
      //   //隐藏背景2
      //   // background2Element.style.display = "none";
      //   //遮罩跟随，隐藏遮罩
      //   var totalDistance = Math.abs(targetPosition4 - targetPosition3);
      //   var currentDistance = Math.abs(pageTop - targetPosition3);
      //   scrollProgress = 1 - currentDistance / totalDistance;
      //   coverimg2Element.style.opacity = scrollProgress;
      //   //隐藏图片3
      //   // bookElement.style.display = "block";
      //   // logo3Element.style.display = "block";
      //   // coverimg2Element.style.display = "block";
      // }


    }, { passive: true });


    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = 'https://uat.kia.cn'
    } else {
      this.preText = 'https://www.kia.cn'
    }
    this.$refs.videoPlayerFull && this.$refs.videoPlayerFull.addEventListener('ended', this.restartPreviewVideo);

  },
  destroyed() {

  },
  methods: {
    closePopAndPlayVideo(){
      this.isShowGold=false
      this.fullVideoUrl = 'https://img.kia.cn/media/videos/202506/dadianying-all-guanwang.mp4'
      this.isShowVideo = true;
      this.isShowCover = true;
      event, PAGEURL, 关闭提示弹窗并播放视频
    },
    closePop(){
      this.isShowGold = false
    },
    stopSwiperVideo() {
      const video1 = document.getElementById("videoPlayerSwiper0")
      const video2 = document.getElementById("videoPlayerSwiper1")
      // const video3 = document.getElementById("videoPlayerSwiper2")
      if(video1){
        video1.pause()
      }
      if(video2){
        video2.pause()
      }
    },
    handleAudio(){
      this.stopSwiperVideo();
      // this.isAudioPlaying = !this.isAudioPlaying;
      // 触发音频播放/暂停事件
      if (!this.isAudioPlaying) {
        this.showAudioText = false;
        this.$emit("playAudio");

      } else {
        this.showAudioText = true;
        this.$emit("stopAudio");

      }
      if(!this.isAudioPlaying){
        stm_clicki("send",'event',window.location.href, "点击", '播放音频');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '播放音频', 1]);
      }else{
        stm_clicki("send",'event',window.location.href, "点击", '暂停音频');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '暂停音频', 1]);
      }
    },
    handleAudioHover(isHovering) {
      this.isHovering = isHovering;
      // 只有在播放状态下，hover才会显示文本
      // if (this.isAudioPlaying) {
      //   this.showAudioText = isHovering;
      // }
    },
    playFullVideo() {
      this.$emit("distinctive", true);
      this.showIcon = false;
      this.showFullVideo = true;
      this.$refs.videoPlayerFull.play();
    },
    restartPreviewVideo() {
      this.$emit("distinctive", false);
      this.showIcon = true;
      this.showFullVideo = false;

    },
    showPopVideo(index) {//index1:kv视频，index2:剧情梗概上 index3:剧情梗概下
      this.stopSwiperVideo();
      //停止音频
      this.showAudioText = true
      this.$emit("stopAudio");
      if (index == 1) {//kv视频
        this.fullVideoUrl = 'https://img.kia.cn/media/videos/202506/dadianying-all-guanwang.mp4';
        stm_clicki("send",'event',window.location.href, "点击", '完整视频播放');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '完整视频播放', 1]);
      }
      if (index == 2) {//剧情梗概上
        this.fullVideoUrl = 'https://img.kia.cn/media/videos/202506/dadianying-befo-guanwang.mp4';

        stm_clicki("send",'event',window.location.href, "点击", '上卷_视频播放');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '上卷_视频播放', 1]);
      }
      if (index == 3) {//剧情梗概下
        this.fullVideoUrl = 'https://img.kia.cn/media/videos/202506/dadianying-after-guanwang.mp4';
        stm_clicki("send",'event',window.location.href, "点击", '下卷_视频播放');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '下卷_视频播放', 1]);
      }
      this.isShowVideo = true;
      this.isShowCover = true;
    },
    // showPopVideo(index) {//index1:kv视频，index2:剧情梗概上 index3:剧情梗概下
    //   this.isShowVideo = true;
    //   this.isShowCover = true;
    // },
    hideCover2() {
      this.isShowVideo = false;
      this.isShowCover = false;
    },
    close() {
      this.$emit("open");
      this.videoVisible = false;
      let hideobj = document.getElementById("hidebg");
      hideobj.style.display = "none";
    },
    playVideo(index) {
      let videos = document.querySelectorAll(".swiper-video");
      console.log(123123, index, isNaN(index));
      if (videos.length > 0 && !isNaN(index)) {
        videos[index].play();
      }
    },


    /*第三屏开始*/

    hideCover() {
      this.isShowPop = false;
    },
    showPop(index) {
      this.isShowPop = true;
      this.popimgSrc = this.popimgList[index].src;
      // this.isShowPop = true;
      // this.popimgSrc = src;
    },
    calculateScale(scrollProgress) {
      // 计算缩放比例
      let scale = 1 * (1 - scrollProgress) + 0.2;
      // 如果缩放比例小于1，则加上0.1
      if (scale < 1) {
        scale += 0.1;
      }
      // 如果最终缩放比例超过1，则将其设为1
      if (scale > 1) {
        scale = 1;
      }
      return scale;
    },

  },
};
</script>

<style scoped lang="scss">
.static-1 {
  width: 100%;
  .page {
    width: 100%;
    position: relative;
    .video-overlay {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      background-color: rgba(0, 0, 0, 0);
      backdrop-filter: blur(0px);
      //background: linear-gradient(
      //    45deg,
      //    rgba(20,30,40,0.8) 0%,
      //    rgba(80,100,120,0.4) 100%
      //);
      //mix-blend-mode: multiply;


      //backdrop-filter: blur(calc(var(--scroll-progress) * 10px));
      //mask-image: linear-gradient(
      //    to bottom,
      //    transparent calc(100% - var(--scroll-progress)*100%),
      //    #fff 100%
      //);
      //transition: backdrop-filter 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    }
    .video-box {
      position: fixed;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100vh;
      .swiper-video {
        transform: translate(-50%, -50%);
        min-width: 100%;
        min-height: 100%;
        z-index: -1;
        object-fit: cover;
        // opacity: 0.5;
        filter: grayscale(20%) contrast(110%);
        width: 100%;
        height: 100vh;
      }
    }

    .page-1 {
      width: 100%;
      height: 100vh;
      position: relative;
      z-index: 3;
      .logo-box {
        position: absolute;
        left: 6vw;
        top: 17.3vh;
        img {
          width: 454px;
          object-fit: cover;
        }
      }
      .left-text {
        position: absolute;
        left: 1.3vw;
        top: 22.6vh;
        img {
          width: 18px;
          height: 545px;
          object-fit: contain;
        }
      }
      .audio-play {
        width: calc(242 / 2200 * 100vw);
        height: calc(73 / 2200 * 100vw);
        position: absolute;
        // left: 50%;
        left: calc(6vw + 10px + 10px + calc(242 / 2200 * 100vw));
        top: calc(17.5vh + 195px);
        cursor: pointer;
        img {
          position: relative;
          width: 100%;
          height: 100%;
          transition: transform 0.5s ease;
          z-index: 11;
          &.rotate {
            animation: rotate 3s linear infinite;
          }
        }

        .audio-text {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: calc(242 / 2200 * 100vw);
          height: 100%;
          // transform: translateX(-20px);
          opacity: 0;
          transition: all 0.3s ease;
          pointer-events: none;
          z-index:10;
          &.show {
            // transform: translateX(10px);
            opacity: 1;
          }

          img {
            width: 100%;
            height: 100%;
            animation: none;
          }
        }
      }
      .video-play {
        // width: 242px;
        // height: 73px;
        width: calc(242 / 2200 * 100vw);
        height: calc(73 / 2200 * 100vw);
        box-sizing: border-box;
        padding-left: 1px;
        position: absolute;
        // left: 50%;
        left: calc(6vw + 10px);
        top: calc(17.5vh + 195px);
        // bottom: 14.5vh;
        // bottom: calc(150 / 2200 * 100vw);
        // transform: translate(-50%, 0);
        display: flex;
        background-color: rgba(128, 128, 128,0.3);
        border-radius: 30px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        .video-play-text {
          flex: 1;
          text-align: center;
          line-height: 60px;
          color: #ffffff;
          font-size: 16px;
        }
      }
    }
    .page-2 {
      width: 100%;
      height: 100vh;
      position: relative;
      background-color: rgba(128,128,128,0);
      .page-bg1 {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url('https://uat.kia.cn/assets/~/media/images/activity/film2505-prod/pc/page-2-bg2.png');
        background-size: cover;
        background-repeat: no-repeat;
        z-index: 1;
        opacity: 0.2;
        transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      }
      .logo-box {
        position: absolute;
        left: 6vw;
        top: 17.3vh;
        z-index: 3;
        img {
          width: 139px;
          object-fit: cover;
        }
      }
      .page-bg-left {
        // width: 59vw;
        //height: calc(887 / 1238 * 100vh);
        // height: calc(887 / 2200 * 100vw);
        width: calc(1094 / 2200 * 100vw);
        height: calc(1093 / 2200 * 100vw);


        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 3;
        // opacity: 0;
        //transform: scale(0.5);
        transform-origin: left bottom;
        // background-image: url(https://uat.kia.cn/assets/~/media/images/activity/film2505-prod/pc/page-2-bg1.png);
        background-image: url(https://uat.kia.cn/assets/~/media/images/activity/film2505-prod/pc/page-2-bg1-1.png);
        background-position: left bottom;
        background-size: 100% 100%;
        img {
          width: 59vw;
          object-fit: cover;
          position: relative;
          left: 0;
          bottom: 0;
        }
      }
      .text-box {
        width: 47.9vw;
        height: 100%;
        position: relative;
        left: 50%;
        top: 0;
        transform: translate(-50%, 0);
        z-index: 3;
        .text-1 {
          position: absolute;
          left: 0;
          top: 21.89vh;
          img  {
            width: 14.6vw;
            object-fit: cover;
          }
        }
        .text-2 {
          position: absolute;
          right: 0;
          //top: 24.6vh;
          top: calc(300 / 1238 * 100vh);
          img {
            display: block;
          }
          .text-2-img1 {
            width: 21.5vw;
            object-fit: cover;
          }
          .text-2-img2 {
            width: 13.4vw;
            object-fit: cover;
            margin-top: 8.5vh;
            animation-duration: 2s !important;
          }
        }
      }
    }
    .bg {
      background-image: url('https://uat.kia.cn/assets/~/media/images/activity/film2505-prod/pc/page-2-bg2.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .play-audio {
    cursor: pointer;
    width: calc(74 / 2200 * 100vw);
    height: calc(88 / 2200 * 100vw);
    position: fixed;
    bottom: calc(80 / 2200 * 100vw);
    left: calc(68 / 2200 * 100vw + 73 / 2200 * 100vw + 20 / 2200 * 100vw);
    z-index: 999;
    img {
      position: relative;
      width: 100%;
      height: 100%;
      transition: transform 0.5s ease;
      z-index: 1000;
      &.rotate {
        animation: rotate 3s linear infinite;
      }
    }

    .audio-text {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(73 / 2200 * 100vw);
      height: 100%;
      // transform: translateX(-20px);
      opacity: 0;
      transition: all 0.3s ease;
      pointer-events: none;
      z-index:999;
      &.show {
        // transform: translateX(10px);
        opacity: 1;
      }

      img {
        width: 100%;
        height: 100%;
        animation: none;
      }
    }
  }

  .play-video {
    width: calc(60 / 2200 * 100vw);
    height: calc(88 / 2200 * 100vw);
    position: fixed;
    // top: calc(81 / 1238 * 100vh);
    // right: calc(73 / 2200 * 100vw);
    bottom: calc(80 / 2200 * 100vw);
    left: calc(68 / 2200 * 100vw);
    z-index: 999;
    cursor: pointer;
  }
  .cover-video {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 1000;

    // .el-icon-close {
    //   color: #fff;
    //   font-size: 30px;
    //   cursor: pointer;
    //   position: absolute;
    //   z-index: 99;
    //   right: 20px;
    //   top: 50px;
    // }
    .pop {
      position: relative;
      height: 100%;
      width: 100%;
    }

    .pop-video {
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
      video {
        object-fit: contain;
        width: 100%;
        height: 100vh;
      }
    }

    .error-icon {
      position: absolute;
      top: 2%;
      left: 88%;

      @media (min-width: 768px) {
        top: 1%;
        left: 95%;
      }

      // transform: translateX(-50%);
      font-size: 30px;

      color: #818181;

      &:hover {
        color: #fff;
      }
    }
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="scss" scoped>
.animatepage {
  position: relative;
  // height: calc(50vh + (1238 / 2200) * 100vw + (1238 / 2200) * 100vw + (1230 / 2200) * 100vw);
  // height: calc(25vh + (1238 / 2200) * 100vw + (1230 / 2200) * 100vw);
  height: calc(25vh + (1245 / 2200) * 100vw + (1238 / 2200) * 100vw + (1230 / 2200) * 100vw);
  width: 100%;
  user-select: none;
  // background-color: rgba(19, 25, 28);
  background-color: rgba(19, 25, 28);
  .overlay {
    display: none;
    // position: fixed;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    // background-color: #000;
    background-color: rgba(19, 25, 28);
    // background: linear-gradient(to top, #101415, rgba(29, 29, 33));
    z-index: 15;
  }

  .background1 {
    display: none;
    // background-color: rgba(19, 25, 28);
    background-color: transparent;
    // opacity: 1;
    top: 78px;
    // transition: opacity 1s;
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 9;
    transform-origin: right top;
    transition: transform  ease-out;
  }
  .background2 {
    display: none;
    // background-color: rgba(19, 25, 28);
    // opacity: 1;
    top: 0;
    right: 0;
    // transition: opacity 1s;
    position: absolute;
    width: calc((1295 / 2200) * 100vw);
    height: calc((959 / 2200) * 100vw);
    z-index: 9;
    transform-origin: right top;
    transition: transform  ease-out;
  }

  .coverimg1 {
    position: relative;
    // left: calc(283 / 2200 * 100vw);
    // bottom:0;
    height: calc(25vh + (1245 / 2200) * 100vw);
    padding-top: calc(25vh + 176 / 2200 * 100vw);
    // padding-left: calc(294 / 2200 * 100vw);
    z-index: 20;

    img {
      width: 100%;
      height: calc(1069 / 2200 * 100vw);
    }
  }

  .coverimg2 {
    position: relative;
    height: calc((1238 / 2200) * 100vw);
    z-index: 12;
    // padding-bottom: calc(157 / 2200 * 100vw);
    // padding-left: calc(266 / 2200 * 100vw);
    // img {
    //   margin-top: calc(236 / 2200 * 100vw);
    //   width: calc(1596 / 2200 * 100vw);
    //   height: calc(782 / 2200 * 100vw);
    // }
    img{
      position: absolute;
    }
    .pic {
      width: calc(342 / 2200 * 100vw);
      height: calc(204 / 2200 * 100vw);
      z-index: 14;
      cursor: pointer;
      transition: transform ease;
    }
    .pic:hover {
      transform: scale(1.03);
    }
    .big-bg {
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
    }
    .juzhao-logo {
      position: absolute;
      top: calc(255 / 2200 * 100vw);
      left: calc(1677 / 2200 * 100vw);
      width: calc(189 / 2200 * 100vw);
      height: calc(178 / 2200 * 100vw);
    }
    .bg {
      z-index: 13;
    }
    .bg-1 {
      top: calc(263 / 2200 * 100vw);
      left: calc(266 / 2200 * 100vw);
      width: calc(403 / 2200 * 100vw);
      height: calc(591 / 2200 * 100vw);
    }
    .bg-2 {
      top: calc(217 / 2200 * 100vw);
      left: calc(684 / 2200 * 100vw);
      width: calc(402 / 2200 * 100vw);
      height: calc(876 / 2200 * 100vw);
    }
    .bg-3 {
      top: calc(279 / 2200 * 100vw);
      left: calc(1103 / 2200 * 100vw);
      width: calc(402 / 2200 * 100vw);
      height: calc(886 / 2200 * 100vw);
    }
    .bg-4 {
      top: calc(433 / 2200 * 100vw);
      left: calc(1521 / 2200 * 100vw);
      width: calc(402 / 2200 * 100vw);
      height: calc(582 / 2200 * 100vw);
    }
    .pic-1 {
      top: calc(286 / 2200 * 100vw);
      left: calc(296 / 2200 * 100vw);
    }
    .pic-2 {
      top: calc(240 / 2200 * 100vw);
      left: calc(714 / 2200 * 100vw);
    }
    .pic-3 {
      top: calc(310 / 2200 * 100vw);
      left: calc(1133 / 2200 * 100vw);
    }
    .pic-4 {
      top: calc(460 / 2200 * 100vw);
      left: calc(1551 / 2200 * 100vw);
    }
    .pic-5 {
      top: calc(560 / 2200 * 100vw);
      left: calc(296 / 2200 * 100vw);
    }
    .pic-6 {
      top: calc(526 / 2200 * 100vw);
      left: calc(714 / 2200 * 100vw);
    }
    .pic-7 {
      top: calc(584 / 2200 * 100vw);
      left: calc(1133 / 2200 * 100vw);
    }
    .pic-8 {
      top: calc(740 / 2200 * 100vw);
      left: calc(1551 / 2200 * 100vw);
    }
    .pic-9 {
      top: calc(788 / 2200 * 100vw);
      left: calc(714 / 2200 * 100vw);
    }
    .pic-10 {
      top: calc(880 / 2200 * 100vw);
      left: calc(1133 / 2200 * 100vw);
    }
  }
  .coverimg3 {
    position: relative;
    height: calc((1230 / 2200) * 100vw);
    width: 100%;
    // z-index: 12;
    .big-bg {
      z-index: 15 !important;
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
    }
    .cover3-img {
      position: absolute;

      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 14;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .button-play {
      position: absolute;
      z-index: 16;
      cursor: pointer;
      width: calc((80 / 2200) * 100vw);
      height: calc((80 / 2200) * 100vw);
      left: calc((360 / 2200) * 100vw);
      // background-color: #000000;
    }
    .button-up {
      top:calc((576 / 2200) * 100vw);
    }
    .button-down {
      top:calc(((576 + 220)  / 2200) * 100vw);
    }
  }

  .pop-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }
  .pop-img {
    position: fixed;
    width: calc(1053 / 2200 * 100vw);
    height: calc(715 / 2200 * 100vw);
    z-index: 10000;
    left: calc(50% - 526.5 / 2200 * 100vw);
    top: calc(50% - 357.5 / 2200 * 100vw);
    img {
      width: 100%;
      height: 100%;
    }
    /* padding: calc(216 / 3225 * 100vh) calc(225 / 3225 * 100vh) calc(72 / 3225 * 100vh) calc(225 / 3225 * 100vh); */
  }
  .pop-close {
    position: fixed;
    z-index: 10000;
    left: calc(50% + 526.5 / 2200 * 100vw);
    top: calc(50% - 357.5 / 2200 * 100vw);
    width: calc(36 / 2200 * 100vw);
    height: calc(36 / 2200 * 100vw);
    cursor: pointer;
  }

  .logo-box {
    z-index: 30 !important;
    position: absolute;
    left: 6vw;
    top: 25.3vh;
    z-index: 3;
    img {
      width: 139px;
      object-fit: cover;
    }
  }
  .logo-box2 {
    z-index: 12 !important;
    position: absolute;
    left: 6vw;
    top: calc(25.3vh + (1238 / 2200) * 100vw);
    z-index: 3;
    img {
      width: 139px;
      object-fit: cover;
    }
  }
  .logo-box3 {
    z-index: 12 !important;
    position: absolute;
    left: 6vw;
    top: calc(55.3vh + (1238 / 2200) * 100vw + (1238 / 2200) * 100vw);
    img {
      width: 139px;
      object-fit: cover;
    }
  }
}
.gold-cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #606060C4;
    z-index: 999
  }
  .gold-el-icon-close {
      color: #fff;
      cursor: pointer;
      position: fixed;
      z-index: 1000;
      right: calc(50vw - 511.5 / 1237 * 100vh + 15 / 1237 * 100vh);
      top: calc(50vh - 412 / 1237 * 100vh - 51.23 / 1237 * 100vh);
      width: calc(111 / 1237 * 100vh);
      height: calc(51.23 / 1237 * 100vh);
    }

    .gold-pop {
      z-index: 1000;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(1023 / 1237 * 100vh);
      height: calc(824 / 1237 * 100vh);
      img{
        width: 100%;
        height: 100%;
      }
    }
    .click-area{
      position: fixed;
      z-index: 1001;
      top: 50%;
      left: 50%;
      transform: translate(-50%, calc(-50% + -75 / 1237 * 100vh));
      width: calc(1000 / 1237 * 100vh);
      height: calc(670 / 1237 * 100vh);
      // background-color: turquoise;
      // opacity: 0.4;
      cursor: pointer;
    }
  ::v-deep .el-dialog{
    background-color: transparent;
    box-shadow: none;
  }
  ::v-deep .el-dialog__headerbtn {
    display: none;
  }
</style>
